// extracted by mini-css-extract-plugin
var _1 = "src-components-LoginForm-_TextDialog__dialogCloseButton--rtpXVIEVDbCQ_8bwJb1H";
var _2 = "src-components-LoginForm-_TextDialog__dialogCloseButtonWrapper--JvsYJR6RewAH_w4B9726";
var _3 = "src-components-LoginForm-_TextDialog__dialogText--PwQu1kPgdloQ8sa9qcIO";
var _4 = "src-components-LoginForm-_TextDialog__textDialog--t4mG6JxN1_6JlKxINdak";
export { _1 as "dialogCloseButton", _2 as "dialogCloseButtonWrapper", _3 as "dialogText", _4 as "textDialog" }
